import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withKeys as _withKeys } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "hamburger"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "bar bar1"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "bar bar2"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "bar bar3"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "bar bar4"
})], -1);
var _hoisted_3 = [_hoisted_2];
var _hoisted_4 = ["src"];
var _hoisted_5 = ["src"];
var _hoisted_6 = ["onClick"];
var _hoisted_7 = ["onClick", "innerHTML"];
var _hoisted_8 = {
  key: 7,
  class: "userprofile"
};
var _hoisted_9 = {
  class: "profile"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = ["onClick"];
var _hoisted_12 = ["src"];
var _hoisted_13 = ["src"];
var _hoisted_14 = ["src"];
var _hoisted_15 = ["src"];
var _hoisted_16 = {
  key: 0
};
var _hoisted_17 = {
  class: "m-0"
};
var _hoisted_18 = {
  class: "listimage-notfound",
  style: {
    "padding": "5px"
  }
};
var _hoisted_19 = {
  style: {
    "margin": "0"
  }
};
var _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
var _hoisted_21 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_RouterLink = _resolveComponent("RouterLink");
  var _component_el_col = _resolveComponent("el-col");
  var _component_el_menu_item = _resolveComponent("el-menu-item");
  var _component_el_menu_item_group = _resolveComponent("el-menu-item-group");
  var _component_el_sub_menu = _resolveComponent("el-sub-menu");
  var _component_el_menu = _resolveComponent("el-menu");
  var _component_el_row = _resolveComponent("el-row");
  var _component_el_icon = _resolveComponent("el-icon");
  var _component_el_badge = _resolveComponent("el-badge");
  var _component_Search = _resolveComponent("Search");
  var _component_PictureFilled = _resolveComponent("PictureFilled");
  var _component_el_image = _resolveComponent("el-image");
  var _component_el_autocomplete = _resolveComponent("el-autocomplete");
  var _component_el_header = _resolveComponent("el-header");
  return _openBlock(), _createElementBlock(_Fragment, null, [!_ctx.pageactive.includes('login') ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.dataheader?.header?.data?.attributes?.message, (message, i) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: i
    }, [message.showmessage && _ctx.checkMercatoBrand(message) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "alertMessageTop",
      innerHTML: message.messagetxt
    }, null, 8, _hoisted_1)) : _createCommentVNode("", true)], 64);
  }), 128)) : _createCommentVNode("", true), _createVNode(_component_el_header, null, {
    default: _withCtx(() => [_createVNode(_component_el_row, {
      class: "row-bg",
      justify: "space-between",
      align: "middle"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        xs: 18,
        sm: 18,
        lg: 16
      }, {
        default: _withCtx(() => [_ctx.dataheader?.header?.data?.attributes?.links?.length > 0 && _ctx.$root.userLogged ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: _normalizeClass(["burge", _ctx.mobileMenu ? 'active' : '']),
          onClick: _cache[0] || (_cache[0] = $event => _ctx.toggleMobileMenu())
        }, _hoisted_3, 2)) : _createCommentVNode("", true), _createVNode(_component_el_row, {
          justify: "start",
          align: "middle"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            xs: 10,
            sm: 10,
            lg: 6,
            class: "logo",
            style: _normalizeStyle(!_ctx.$root.userLogged ? {
              'left': '60px'
            } : '')
          }, {
            default: _withCtx(() => [_createVNode(_component_RouterLink, {
              to: _ctx.$root.userLogged ? `/${_ctx.$root.language}/welcome` : `/${_ctx.$root.language}/login`
            }, {
              default: _withCtx(() => [_ctx.dataheader?.header?.data?.attributes?.logo_header?.data ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.$root.pathcms + _ctx.dataheader.header.data.attributes.logo_header?.data?.attributes?.url
              }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: require('@/assets/logo.png')
              }, null, 8, _hoisted_5))]),
              _: 1
            }, 8, ["to"])]),
            _: 1
          }, 8, ["style"]), _ctx.$root.userLogged ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            xs: 14,
            sm: 14,
            lg: 18,
            class: _normalizeClass(_ctx.mobileMenu && _ctx.$root.mobile ? 'hlinks active' : 'hlinks')
          }, {
            default: _withCtx(() => [_ctx.$root.userLogged && _ctx.userDetail?.currentCustomer?.navigableDitte == null ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: `/${_ctx.$root.language}/shop`,
              style: {
                "display": "inline-block"
              },
              class: _normalizeClass(["main-menu-item", {
                'linkactive': _ctx.pageactive.includes('shop') || _ctx.pageactive.includes('product')
              }])
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Shop')), 1)]),
              _: 1
            }, 8, ["to", "class"])) : _createCommentVNode("", true), _ctx.$root.userLogged && _ctx.userDetail?.currentCustomer?.navigableDitte?.length > 1 ? (_openBlock(), _createBlock(_component_el_menu, {
              key: 1,
              mode: "horizontal",
              ellipsis: false,
              class: "main-menu-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
                index: "0",
                "popper-class": "shop",
                teleported: false
              }, {
                title: _withCtx(() => [_createVNode(_component_RouterLink, {
                  to: `/${_ctx.$root.language}/shop`,
                  class: _normalizeClass({
                    'linkactive': _ctx.pageactive.includes('shop') || _ctx.pageactive.includes('product')
                  })
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Catalog')) + " " + _toDisplayString(_ctx.getDittaLabel(_ctx.currentDitta, _ctx.userDetail?.currentCustomer)), 1)]),
                  _: 1
                }, 8, ["to", "class"])]),
                default: _withCtx(() => [_createVNode(_component_el_menu_item_group, {
                  title: _ctx.$t('Change Shop')
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userDetail.currentCustomer.navigableDitte, ditte => {
                    return _openBlock(), _createBlock(_component_el_menu_item, {
                      key: ditte.ditta
                    }, {
                      default: _withCtx(() => [_createElementVNode("a", {
                        style: {
                          "margin-left": "0"
                        },
                        onClick: $event => _ctx.changeDitta(ditte.code, ditte.ditta)
                      }, _toDisplayString(_ctx.getDittaShippingLabel(ditte.ditta)), 9, _hoisted_6)]),
                      _: 2
                    }, 1024);
                  }), 128))]),
                  _: 1
                }, 8, ["title"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _ctx.dataheader?.header?.data?.attributes?.links?.length ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 2
            }, _renderList(_ctx.dataheader.header.data.attributes.links, link => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: link.id
              }, [link.link_url ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: link.link_url,
                class: _normalizeClass(["main-menu-item", {
                  'linkactive': link.link_url === _ctx.pageactive
                }])
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(link.link_title), 1)]),
                _: 2
              }, 1032, ["to", "class"])) : _createCommentVNode("", true)], 64);
            }), 128)) : _createCommentVNode("", true), _ctx.$root.userAuthorizations.showQuickOrder ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 3,
              to: `/${_ctx.$root.language}/quick-order`,
              style: {
                "display": "inline-block"
              },
              class: _normalizeClass(["main-menu-item", {
                'linkactive': _ctx.pageactive.includes('quick-order')
              }])
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Quick order')), 1)]),
              _: 1
            }, 8, ["to", "class"])) : _createCommentVNode("", true), _ctx.currentDitta === '002' || _ctx.currentDitta === 'HGK' ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 4,
              to: `/${_ctx.$root.language}/availability`,
              style: {
                "display": "inline-block"
              },
              class: _normalizeClass(["main-menu-item", {
                'linkactive': _ctx.pageactive.includes('availability')
              }])
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Disponibilità')), 1)]),
              _: 1
            }, 8, ["to", "class"])) : _createCommentVNode("", true), _ctx.$root.userLogged && _ctx.userDetail?.currentCustomer?.navigableDitte == null ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 5,
              to: `/${_ctx.$root.language}/virtual-show-room`,
              style: {
                "display": "inline-block"
              },
              class: _normalizeClass(["main-menu-item", {
                'linkactive': _ctx.pageactive.includes('virtual-show-room')
              }])
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Virtual Showroom')), 1)]),
              _: 1
            }, 8, ["to", "class"])) : _createCommentVNode("", true), _ctx.$root.userLogged && _ctx.userDetail?.currentCustomer?.navigableDitte?.length > 1 ? (_openBlock(), _createBlock(_component_el_menu, {
              key: 6,
              mode: "horizontal",
              ellipsis: false,
              class: "main-menu-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
                index: "0",
                "popper-class": "shop",
                teleported: false
              }, {
                title: _withCtx(() => [_createVNode(_component_RouterLink, {
                  to: `/${_ctx.$root.language}/virtual-show-room`,
                  class: _normalizeClass({
                    'linkactive': _ctx.pageactive.includes('virtual-show-room')
                  })
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Virtual Showroom')) + " " + _toDisplayString(_ctx.getDittaLabel(_ctx.currentDitta, _ctx.userDetail?.currentCustomer)), 1)]),
                  _: 1
                }, 8, ["to", "class"])]),
                default: _withCtx(() => [_createVNode(_component_el_menu_item_group, {
                  title: _ctx.$t('Change Showroom')
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userDetail.currentCustomer.navigableDitte, ditte => {
                    return _openBlock(), _createBlock(_component_el_menu_item, {
                      key: ditte.ditta
                    }, {
                      default: _withCtx(() => [_createElementVNode("a", {
                        style: {
                          "margin-left": "0"
                        },
                        onClick: $event => _ctx.changeDitta(ditte.code, ditte.ditta, false),
                        innerHTML: _ctx.getDittaLabel(ditte.ditta, _ctx.userDetail?.currentCustomer)
                      }, null, 8, _hoisted_7)]),
                      _: 2
                    }, 1024);
                  }), 128))]),
                  _: 1
                }, 8, ["title"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _ctx.$root.userLogged ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
              src: require('@/assets/user.svg')
            }, null, 8, _hoisted_10), _createTextVNode(" " + _toDisplayString(_ctx.userDetail.firstName) + " " + _toDisplayString(_ctx.userDetail.lastName), 1)]), _createVNode(_component_RouterLink, {
              to: `/${_ctx.$root.language}/user-area/profile`
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Profilo utente')), 1)]),
              _: 1
            }, 8, ["to"]), _createVNode(_component_RouterLink, {
              to: "/"
            }, {
              default: _withCtx(() => [_createElementVNode("b", null, _toDisplayString(_ctx.userDetail.currentCustomer.name), 1)]),
              _: 1
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userDetail.customers, client => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: client.code
              }, [!_ctx.checkCustomer(client) ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: $event => _ctx.changeclient(client.code, client.ditta, client.name)
              }, _toDisplayString(client.alias || client.name), 9, _hoisted_11)) : _createCommentVNode("", true)], 64);
            }), 128)), _ctx.$root.userAuthorizations.showSavedOrders ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 0,
              to: '/' + _ctx.$root.language + '/user-area/saved-carts'
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Carrelli salvati')), 1)]),
              _: 1
            }, 8, ["to"])) : _createCommentVNode("", true), _ctx.$root.userAuthorizations.showOrders ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 1,
              to: `/${_ctx.$root.language}/user-area/orders`
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Ordini')), 1)]),
              _: 1
            }, 8, ["to"])) : _createCommentVNode("", true), _ctx.$root.userAuthorizations.showInvoices ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 2,
              to: `/${_ctx.$root.language}/user-area/invoices`
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Fatture')), 1)]),
              _: 1
            }, 8, ["to"])) : _createCommentVNode("", true), _ctx.$root.userAuthorizations.showTransportDocument ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 3,
              to: `/${_ctx.$root.language}/user-area/waybills`
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Bolle')), 1)]),
              _: 1
            }, 8, ["to"])) : _createCommentVNode("", true), _ctx.$root.userAuthorizations.showWishlist ? (_openBlock(), _createBlock(_component_RouterLink, {
              key: 4,
              to: `/${_ctx.$root.language}/user-area/wishlists`
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Wishlists')), 1)]),
              _: 1
            }, 8, ["to"])) : _createCommentVNode("", true), _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = (...args) => _ctx.logout && _ctx.logout(...args))
            }, _toDisplayString(_ctx.$t('Disconnetti')), 1)])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["class"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        xs: 6,
        sm: 6,
        lg: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          justify: "end",
          align: "middle",
          class: "operativeMenu"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_menu, {
            mode: "horizontal",
            ellipsis: false
          }, {
            default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
              index: "4",
              "popper-class": "languagemenu",
              teleported: false
            }, {
              title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.activeLang.toUpperCase()), 1)]),
              default: _withCtx(() => [_createVNode(_component_el_menu_item, null, {
                default: _withCtx(() => [_createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = $event => _ctx.setLang('it')),
                  class: _normalizeClass(_ctx.activeLang === 'it' ? 'text-bold' : '')
                }, "IT", 2)]),
                _: 1
              }), _createVNode(_component_el_menu_item, null, {
                default: _withCtx(() => [_createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = $event => _ctx.setLang('en')),
                  class: _normalizeClass(_ctx.activeLang === 'en' ? 'text-bold' : '')
                }, "EN", 2)]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_menu_item, {
              index: "1"
            }, {
              default: _withCtx(() => [_ctx.$root.userLogged ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[4] || (_cache[4] = $event => _ctx.openSearchDiv())
              }, [_createElementVNode("img", {
                src: require('@/assets/search.svg'),
                style: {
                  "width": "28px"
                }
              }, null, 8, _hoisted_12)])) : _createCommentVNode("", true)]),
              _: 1
            }), _ctx.$root.userLogged && _ctx.userDetail ? (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 0,
              index: "2",
              class: "usermenu"
            }, {
              title: _withCtx(() => [_createElementVNode("img", {
                src: require('@/assets/user.svg'),
                style: {
                  "width": "28px"
                }
              }, null, 8, _hoisted_13), _createElementVNode("span", null, _toDisplayString(_ctx.userDetail.firstName) + " " + _toDisplayString(_ctx.userDetail.lastName), 1)]),
              default: _withCtx(() => [_createVNode(_component_el_menu_item_group, {
                title: _ctx.$t('Clienti'),
                style: {
                  "max-height": "400px",
                  "overflow": "auto"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_menu_item, null, {
                  default: _withCtx(() => [_createElementVNode("b", null, _toDisplayString(_ctx.userDetail.currentCustomer.name), 1)]),
                  _: 1
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userDetail.customers, client => {
                  return _openBlock(), _createElementBlock(_Fragment, {
                    key: client
                  }, [!_ctx.checkCustomer(client) ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 0,
                    onClick: $event => _ctx.changeclient(client.code, client.ditta, client.name)
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(client.alias || client.name), 1)]),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true)], 64);
                }), 128))]),
                _: 1
              }, 8, ["title"]), _createVNode(_component_el_menu_item, null, {
                default: _withCtx(() => [_createVNode(_component_RouterLink, {
                  to: `/${_ctx.$root.language}/user-area/profile`
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Profilo utente')), 1)]),
                  _: 1
                }, 8, ["to"])]),
                _: 1
              }), _ctx.$root.userAuthorizations.showSavedOrders ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 0
              }, {
                default: _withCtx(() => [_createVNode(_component_RouterLink, {
                  to: '/' + _ctx.$root.language + '/user-area/saved-carts'
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Carrelli salvati')), 1)]),
                  _: 1
                }, 8, ["to"])]),
                _: 1
              })) : _createCommentVNode("", true), _ctx.$root.userAuthorizations.showOrders ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1
              }, {
                default: _withCtx(() => [_createVNode(_component_RouterLink, {
                  to: `/${_ctx.$root.language}/user-area/orders`
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Ordini')), 1)]),
                  _: 1
                }, 8, ["to"])]),
                _: 1
              })) : _createCommentVNode("", true), _ctx.$root.userAuthorizations.showInvoices ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 2
              }, {
                default: _withCtx(() => [_createVNode(_component_RouterLink, {
                  to: `/${_ctx.$root.language}/user-area/invoices`
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Fatture')), 1)]),
                  _: 1
                }, 8, ["to"])]),
                _: 1
              })) : _createCommentVNode("", true), _ctx.$root.userAuthorizations.showTransportDocument ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 3
              }, {
                default: _withCtx(() => [_createVNode(_component_RouterLink, {
                  to: `/${_ctx.$root.language}/user-area/waybills`
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Bolle')), 1)]),
                  _: 1
                }, 8, ["to"])]),
                _: 1
              })) : _createCommentVNode("", true), _ctx.$root.userAuthorizations.showWishlist ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 4
              }, {
                default: _withCtx(() => [_createVNode(_component_RouterLink, {
                  to: `/${_ctx.$root.language}/user-area/wishlists`
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Wishlists')), 1)]),
                  _: 1
                }, 8, ["to"])]),
                _: 1
              })) : _createCommentVNode("", true), _createVNode(_component_el_menu_item, null, {
                default: _withCtx(() => [_createVNode(_component_RouterLink, {
                  to: `/${_ctx.$root.language}/guide-tour`
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Tour guidato')), 1)]),
                  _: 1
                }, 8, ["to"])]),
                _: 1
              }), _createVNode(_component_el_menu_item, null, {
                default: _withCtx(() => [_createElementVNode("a", {
                  onClick: _cache[5] || (_cache[5] = $event => _ctx.logout())
                }, _toDisplayString(_ctx.$t('Disconnetti')), 1)]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _ctx.$root.userLogged && _ctx.$root.userAuthorizations.showWishlist && _ctx.currentDitta === 'STK' ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 1,
              index: "3"
            }, {
              default: _withCtx(() => [_createVNode(_component_RouterLink, {
                to: `/${_ctx.$root.language}/wishlist`
              }, {
                default: _withCtx(() => [_createVNode(_component_el_badge, {
                  value: _ctx.$root.totals.wishlistTotals?.elementCount,
                  class: "item"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createElementVNode("img", {
                      src: require('@/assets/wishlist.svg')
                    }, null, 8, _hoisted_14)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["value"])]),
                _: 1
              }, 8, ["to"])]),
              _: 1
            })) : _createCommentVNode("", true), _ctx.$root.userLogged && _ctx.$root.userAuthorizations.enableCartAndPurchases ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 2,
              index: "3"
            }, {
              default: _withCtx(() => [_createVNode(_component_RouterLink, {
                to: `/${_ctx.$root.language}/cart`
              }, {
                default: _withCtx(() => [_createVNode(_component_el_badge, {
                  value: _ctx.$root.totals.elementCount,
                  class: "item"
                }, {
                  default: _withCtx(() => [_createElementVNode("img", {
                    src: require('@/assets/cart.svg'),
                    style: {
                      "width": "30px"
                    }
                  }, null, 8, _hoisted_15)]),
                  _: 1
                }, 8, ["value"])]),
                _: 1
              }, 8, ["to"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _ctx.searchDiv ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      class: "searchMainDiv",
      id: "searchMainDiv"
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        id: "backdooSearch",
        onClick: _cache[6] || (_cache[6] = $event => {
          this.searchDiv = false;
        })
      }), _createVNode(_component_el_col, null, {
        default: _withCtx(() => [_createVNode(_component_el_autocomplete, {
          onKeyup: _withKeys(_ctx.onEnter, ["enter"]),
          "fetch-suggestions": _ctx.querySearchAsync,
          modelValue: _ctx.inputSearch,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.inputSearch = $event),
          ref: "refSearch",
          type: "text",
          class: "searchGlobal",
          size: "large",
          placeholder: _ctx.$t('Cerca nel sito, articoli per codice'),
          debounce: 800
        }, {
          suffix: _withCtx(() => [_createVNode(_component_el_icon, {
            size: "18"
          }, {
            default: _withCtx(() => [_createVNode(_component_Search)]),
            _: 1
          })]),
          default: _withCtx(({
            item
          }) => [item.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('Scrivi almeno 4 lettere..')), 1)])) : (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            class: "autocompleteItem",
            onClick: $event => _ctx.goToProduct(item.code, item.color)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createVNode(_component_el_image, {
                style: {
                  "width": "100px",
                  "height": "100px"
                },
                fit: "cover",
                src: item?.images[0]?.imageUrl
              }, {
                error: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_icon, {
                  size: 25
                }, {
                  default: _withCtx(() => [_createVNode(_component_PictureFilled)]),
                  _: 1
                }), _createElementVNode("small", null, _toDisplayString(_ctx.$t('Image soon...')), 1)])]),
                _: 2
              }, 1032, ["src"])]),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 16,
              class: "txt"
            }, {
              default: _withCtx(() => [_createElementVNode("p", _hoisted_19, _toDisplayString(item.name), 1), _createElementVNode("strong", null, _toDisplayString(item.code) + " - " + _toDisplayString(item.color), 1), _hoisted_20, _ctx.$root.userAuthorizations.showCatalogPrices ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(item.priceString), 1)) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["onClick"]))]),
          _: 1
        }, 8, ["onKeyup", "fetch-suggestions", "modelValue", "placeholder"])]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  })], 64);
}